import script from "./profile-user.vue?vue&type=script&setup=true&lang=js"
export * from "./profile-user.vue?vue&type=script&setup=true&lang=js"

import "./profile-user.vue?vue&type=style&index=0&id=292eab28&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-292eab28"]])

export default __exports__